import styled from 'styled-components'

const StyledPageSubTitle = styled.h5`
  padding-top: 10px;
  text-transform: capitalize;
  font-size: 14px;
`

export default StyledPageSubTitle
